import { AddOns, BillingCycle, Licenses } from "@nova/constants"
import { z } from "zod"

const pkName = "ownerId"
const skName = "licenseId"

const BaseLicenseSchema = z.object({
    [pkName]: z.string(),
    [skName]: z.string(),
    assigneeAttributes: z
        .object({
            fullName: z.string(),
            email: z.string(),
        })
        .optional(),
    assigneeId: z.string().optional(),
    billingCycle: z.enum(BillingCycle),
    createdAt: z.string(),
    deletedAt: z.string().optional(),
    isLicenseInvitation: z.boolean().optional(),
    isPaymentExpired: z.boolean().optional(),
    subscriptionId: z.string(),
    updatedAt: z.string().optional(),
    /** Internal-only sales/CS commentary — never serve this to the customer-facing app. */
    notes: z.string().optional(),
    expiresAt: z.string().optional(),
})

export const LicenseSchema = BaseLicenseSchema.extend({
    isAddOn: z.literal(false),
    liveVideoTrialExpiration: z.string().optional(),
    subscriptionType: z.enum(Licenses),
    usageAmount: z.number().catch(0),
})

export const AddOnSchema = BaseLicenseSchema.extend({
    isAddOn: z.literal(true),
    liveVideoTrialExpiration: z.preprocess(() => undefined, z.undefined()),
    subscriptionType: z.enum(AddOns),
    usageAmount: z.preprocess(() => undefined, z.undefined()),
})

export const LicenseRecordSchema = z.discriminatedUnion("isAddOn", [LicenseSchema, AddOnSchema])

export type LicenseRecord = z.infer<typeof LicenseRecordSchema>

export type License = z.infer<typeof LicenseSchema>

export type AddOn = z.infer<typeof AddOnSchema>
